var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { f as fetchGet, q as queryOptions, m as getCircumferenceMeasurementsPerProductTypes, n as getMeasurementsPerProductTypes, o as getRecommendedCustomerProfiles, u as useQuery, d as distExports } from "./public-get.api-DzhvurPF.js";
import { useState, useMemo, useEffect } from "react";
import { c as isClientOffline, u as useCircumferenceMeasurementsQuery, m as multiplyProfilesMeasurements, d as multiplyProductProfilesMeasurements } from "./use-circumference-measurements-query.hook-d3jyZ33a.js";
import { a as getProductPassportsByEpc } from "./rtw.api-C8H2KL5A.js";
import { u as useDataDogActionTracking } from "./common-BE7oYkqA.js";
const replaceNullPropsWithEmptyString = (data, propsToReplace) => {
  const convertedData = __spreadValues({}, data);
  propsToReplace.forEach((propName) => {
    if (convertedData.hasOwnProperty(propName) && convertedData[propName] === null) {
      convertedData[propName] = "";
    }
  });
  return __spreadValues({}, convertedData);
};
const getProductProfiles = ({
  accountNr,
  token,
  countryCode,
  fitId,
  productType,
  checkCompatibility,
  epc,
  ignoreMeasurementValues,
  siteId,
  sizePassportId
}) => {
  return fetchGet({
    service: "sizePassportPublicUrl",
    apiVersion: "v1",
    request: "SizePassportProfile/Profiles",
    auth: {
      siteId,
      token
    },
    data: {
      accountNr,
      checkCompatibility: String(checkCompatibility),
      countryCode,
      epc,
      ignoreMeasurementValues: ignoreMeasurementValues !== void 0 ? ignoreMeasurementValues.toString() : "true",
      fitId,
      productTypeId: productType,
      sizePassportId
    }
  });
};
const getProductProfileById = ({
  checkCompatibility,
  countryCode,
  epc,
  token,
  sizePassportId
}) => {
  return fetchGet({
    service: "sizePassportPublicUrl",
    apiVersion: "v1",
    request: "SizePassportProfile/Profile",
    auth: {
      token
    },
    data: {
      checkCompatibility: checkCompatibility ? String(checkCompatibility) : "false",
      countryCode,
      epc,
      sizePassportId
    }
  });
};
const getCustomerProfilesPreview = ({
  accountNr,
  countryCode,
  productType,
  service = "sizePassportUrl",
  token
}) => {
  return fetchGet({
    service,
    apiVersion: "v1",
    request: `Account/${accountNr}/Profiles`,
    auth: {
      token
    },
    data: {
      countryCode,
      ignoreMeasurementValues: "false",
      productTypeId: productType
    }
  });
};
const getProfilesPerProductTypes = ({
  accountNr,
  countryCode,
  token
}) => {
  return fetchGet({
    service: "sizePassportPublicUrl",
    apiVersion: "v1",
    request: `Account/${accountNr}/ProfilePerProductTypes`,
    auth: {
      token
    },
    data: {
      countryCode
    }
  });
};
const queryProductPassportsByEpc = ({
  countryCode,
  epc,
  isEnabled = true,
  token
}) => {
  return queryOptions({
    queryKey: ["productPassportByEpc", countryCode, epc, token],
    queryFn: () => __async(null, null, function* () {
      const response = yield getProductPassportsByEpc({
        countryCode,
        epc,
        token
      });
      let safelyFulfilledProfiles = [];
      if (response.profiles && response.profiles.length > 0) {
        safelyFulfilledProfiles = response.profiles.map((profile) => replaceNullPropsWithEmptyString(profile, ["id"]));
      }
      return __spreadProps(__spreadValues({}, response), {
        profiles: safelyFulfilledProfiles
      });
    }),
    enabled: isEnabled,
    retry: false
  });
};
const queryProfileByPassportId = ({
  checkCompatibility,
  countryCode,
  epc,
  isEnabled = true,
  sizePassportId,
  token
}) => {
  return queryOptions({
    queryKey: ["profileByPassportId", checkCompatibility, countryCode, epc, sizePassportId, token],
    queryFn: () => __async(null, null, function* () {
      const response = yield getProductProfileById({
        checkCompatibility,
        countryCode,
        epc,
        sizePassportId,
        token
      });
      return __spreadProps(__spreadValues({}, response), {
        profile: replaceNullPropsWithEmptyString(response.profile, ["id"])
      });
    }),
    enabled: isEnabled,
    retry: false
  });
};
const queryProfilesByAccountNr = ({
  accountNr,
  checkCompatibility = false,
  countryCode,
  epc,
  fitId,
  ignoreMeasurementValues = true,
  isEnabled = true,
  productType,
  siteId,
  sizePassportId,
  token
}) => {
  return queryOptions({
    /* sizePassportId is intentionally excluded from queryKey as it's irrelevant for this API call */
    queryKey: ["profilesByAccountNr", accountNr, checkCompatibility, countryCode, epc, fitId, ignoreMeasurementValues, productType, siteId, token],
    queryFn: () => __async(null, null, function* () {
      const response = yield getProductProfiles({
        accountNr,
        checkCompatibility,
        countryCode,
        epc,
        fitId,
        ignoreMeasurementValues,
        productType,
        siteId,
        sizePassportId,
        token
      });
      return __spreadProps(__spreadValues({}, response), {
        profiles: response.profiles.map((profile) => replaceNullPropsWithEmptyString(profile, ["id"]))
      });
    }),
    enabled: isEnabled,
    retry: false,
    /**
     * Disable caching time.
     * Because profiles could be updated and queries keys will stay the same,
     * it's better to not save response to cache.
     * */
    gcTime: 0
  });
};
const customerProfilesPreviewQuery = ({
  accountNr,
  countryCode,
  isEnabled = true,
  productType,
  service,
  token
}) => {
  return queryOptions({
    /* `service` is part of the key: the two APIM products answer the same request with different
     * authorization, so a cached entry from one must not satisfy the other. */
    queryKey: ["productProfilesPreview", accountNr, countryCode, productType, service, token],
    queryFn: () => __async(null, null, function* () {
      const response = yield getCustomerProfilesPreview({
        accountNr,
        countryCode,
        productType,
        service,
        token
      });
      return response.map((profile) => replaceNullPropsWithEmptyString(profile, ["id"]));
    }),
    enabled: isEnabled,
    retry: 1
  });
};
const customerRecommendedProfilesQuery = ({
  accountNr,
  countryCode,
  isEnabled = true,
  token
}) => {
  return queryOptions({
    queryKey: ["customerRecommendedProfiles", accountNr, countryCode, token],
    queryFn: () => getRecommendedCustomerProfiles({
      accountNr,
      countryCode,
      token
    }),
    enabled: isEnabled,
    retry: false
  });
};
const queryProfilesPerProductTypes = ({
  accountNr,
  countryCode,
  isEnabled = true,
  token
}) => {
  return queryOptions({
    queryKey: ["profilesPerProductTypes", accountNr, countryCode, token],
    queryFn: () => getProfilesPerProductTypes({
      accountNr,
      countryCode,
      token
    }),
    enabled: isEnabled,
    retry: false
  });
};
const queryCircumferenceMeasurementsPerProductTypes = ({
  isEnabled = true,
  productTypeIds
}) => {
  return queryOptions({
    queryKey: ["circumferenceMeasurementsPerProductTypes", productTypeIds],
    queryFn: () => getCircumferenceMeasurementsPerProductTypes(productTypeIds),
    enabled: isEnabled,
    retry: false
  });
};
const queryMeasurementsPerProductTypes = ({
  countryCode,
  isEnabled = true,
  productTypeIds
}) => {
  return queryOptions({
    queryKey: ["measurementsPerProductTypes", countryCode, productTypeIds],
    queryFn: () => getMeasurementsPerProductTypes({
      countryCode,
      productTypeIds
    }),
    enabled: isEnabled,
    retry: false
  });
};
function useProfilesByAccountNrQuery({
  accountNr,
  client,
  countryCode,
  epc,
  fitId,
  isDisabledProfileOnTop = false,
  isEnabled = true,
  isMeasurementsIgnored = true,
  isSortingEnabled = true,
  productType,
  siteId,
  sizePassportId,
  sortingProfileFn,
  token
}) {
  const [initialPassportId] = useState(sizePassportId);
  const [isCircumferenceMappingEnabled] = useState(isClientOffline(client));
  const {
    trackAction
  } = useDataDogActionTracking();
  const profilesQuery = useQuery(queryProfilesByAccountNr({
    accountNr,
    checkCompatibility: true,
    countryCode,
    epc,
    fitId,
    ignoreMeasurementValues: isMeasurementsIgnored,
    isEnabled,
    productType,
    siteId,
    sizePassportId: initialPassportId,
    token
  }));
  const circumferenceMeasurementsQuery = useCircumferenceMeasurementsQuery({
    isEnabled: profilesQuery.isSuccess,
    isAllowed: isCircumferenceMappingEnabled,
    productType
  });
  const isSuccess = useMemo(() => profilesQuery.isSuccess && circumferenceMeasurementsQuery.isSuccess, [circumferenceMeasurementsQuery.isSuccess, profilesQuery.isSuccess]);
  const responseData = useMemo(() => {
    let initialData = {
      productTypeId: productType,
      profiles: [],
      totalCount: 0
    };
    if (isSuccess && profilesQuery.data) {
      initialData = __spreadValues({}, profilesQuery.data);
      if (isCircumferenceMappingEnabled) {
        initialData = multiplyProfilesMeasurements(circumferenceMeasurementsQuery.data, profilesQuery.data);
      }
      if (isSortingEnabled) {
        initialData.profiles = sortingProfileFn(initialData.profiles, initialPassportId, isDisabledProfileOnTop);
      }
    }
    return initialData;
  }, [circumferenceMeasurementsQuery.data, isCircumferenceMappingEnabled, isDisabledProfileOnTop, isSuccess, isSortingEnabled, initialPassportId, productType, profilesQuery.data, sortingProfileFn]);
  useEffect(() => {
    if (profilesQuery.error) {
      trackAction({
        eventName: "meas-profiles-load-failure",
        eventDetails: {
          accountNr,
          client,
          countryCode,
          epc,
          errorDetails: profilesQuery.error,
          fitId,
          productTypeId: productType,
          sizePassportId
        },
        eventType: "error"
      });
    }
  }, [accountNr, client, countryCode, epc, fitId, productType, profilesQuery.error, sizePassportId, trackAction]);
  return {
    isLoading: profilesQuery.isLoading || circumferenceMeasurementsQuery.isLoading,
    isSuccess,
    error: profilesQuery.error || circumferenceMeasurementsQuery.error,
    data: responseData
  };
}
function useProfilesPreviewByAccountNrQuery(t0) {
  "use memo";
  const $ = distExports.c(18);
  const {
    accountNr,
    circumferenceMeasurementIds,
    countryCode,
    isEnabled: t1,
    productType,
    token
  } = t0;
  const isEnabled = t1 === void 0 ? true : t1;
  let t2;
  if ($[0] !== accountNr || $[1] !== countryCode || $[2] !== isEnabled || $[3] !== productType || $[4] !== token) {
    t2 = customerProfilesPreviewQuery({
      accountNr,
      countryCode,
      isEnabled,
      productType,
      service: "sizePassportPublicUrl",
      token
    });
    $[0] = accountNr;
    $[1] = countryCode;
    $[2] = isEnabled;
    $[3] = productType;
    $[4] = token;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const profilesQuery = useQuery(t2);
  const {
    refetch: refetchProfilesQuery
  } = profilesQuery;
  let t3;
  if ($[6] !== refetchProfilesQuery) {
    t3 = () => {
      refetchProfilesQuery();
    };
    $[6] = refetchProfilesQuery;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const refetchProfiles = t3;
  const {
    data,
    error,
    isLoading,
    isSuccess
  } = profilesQuery;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let profiles = t4;
  if (isSuccess && data) {
    let t52;
    if ($[9] !== circumferenceMeasurementIds || $[10] !== data) {
      t52 = circumferenceMeasurementIds.length ? multiplyProductProfilesMeasurements(circumferenceMeasurementIds, data) : data;
      $[9] = circumferenceMeasurementIds;
      $[10] = data;
      $[11] = t52;
    } else {
      t52 = $[11];
    }
    profiles = t52;
  }
  let t5;
  if ($[12] !== error || $[13] !== isLoading || $[14] !== isSuccess || $[15] !== profiles || $[16] !== refetchProfiles) {
    t5 = {
      error,
      isLoading,
      isSuccess,
      profiles,
      refetch: refetchProfiles
    };
    $[12] = error;
    $[13] = isLoading;
    $[14] = isSuccess;
    $[15] = profiles;
    $[16] = refetchProfiles;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
export {
  queryCircumferenceMeasurementsPerProductTypes as a,
  queryMeasurementsPerProductTypes as b,
  customerRecommendedProfilesQuery as c,
  useProfilesPreviewByAccountNrQuery as d,
  queryProductPassportsByEpc as e,
  queryProfileByPassportId as f,
  queryProfilesPerProductTypes as q,
  useProfilesByAccountNrQuery as u
};
